import { render, staticRenderFns } from "./UsageTrend.vue?vue&type=template&id=8e2de2a0&"
import script from "./UsageTrend.vue?vue&type=script&lang=ts&"
export * from "./UsageTrend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports